const state = {
  active: false, // Global loader state
  manualLoader: false, // Manual loader state
  text: '', // Loader text
  ongoingCalls: 0, // Track ongoing API calls
};

const mutations = {
  SET_LOGO_LOADER(state, active) {
    state.active = active;
  },
  SET_LOGO_TEXT(state, text) {
    state.text = text;
  },

  INCREMENT_ONGOING_CALLS(state) {
    state.ongoingCalls++;
    state.active = true;
  },
  DECREMENT_ONGOING_CALLS(state) {
    if (state.ongoingCalls > 0) {
      state.ongoingCalls--;
    }
    if (state.ongoingCalls === 0 && !state.manualLoader) {
      state.active = false;
    }
  },
  SET_MANUAL_LOADER(state, active) {
    state.manualLoader = active;
    state.active = active || state.ongoingCalls > 0; // Show loader if manual loader or ongoing calls are active
  },
};

const actions = {
  set({ commit }, active) {
    commit("SET_LOGO_LOADER", active);
  },
  text({ commit }, text) {
    commit("SET_LOGO_TEXT", text);
  },
  incrementCalls({ commit }) {
    commit("INCREMENT_ONGOING_CALLS");
  },
  decrementCalls({ commit }) {
    commit("DECREMENT_ONGOING_CALLS");
  },
  setManualLoader({ commit }, active) {
    commit("SET_MANUAL_LOADER", active);
  },
};

const getters = {
  active: (state) => state.active,
  text: (state) => state.text,
  ongoingCalls: (state) => state.ongoingCalls,
  manualLoader: (state) => state.manualLoader,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
